const stats = [
  { label: "Hours Volunteering in the Community", value: "1,000+" },
  {
    label: "Conversations with people experiencing homelessness",
    value: "500+",
  },
  { label: "Coffees to those in need", value: "120+" },
  { label: "Hours Volunteered with the RSPCA", value: "64+" },
];

export default function Example() {
  return (
    <div className="py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <div className="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
            <div className="lg:flex lg:flex-auto lg:justify-center">
              <dl className="w-64 space-y-8 xl:w-80">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col-reverse gap-y-2"
                  >
                    <dt className="text-base/7 text-gray-600 font-bold">
                      {stat.label}
                    </dt>
                    <dd className="text-5xl font-black tracking-tight text-gold">
                      {stat.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
            <div className="lg:w-full lg:max-w-2xl lg:flex-auto">
              <h2 className="text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl mb-10">
                Beyond Sport
              </h2>
              <p className="text-xl/8 text-gray-600">
                At WattleNest, our athletes are more than just sportspeople —
                they are changemakers who give back to the community in powerful
                and meaningful ways. Together, our athletes have led over 500
                conversations with people experiencing homelessness, provided
                more than 120 coffees to those in need, and volunteered 64 hours
                with the RSPCA. They have supported major events like the
                Lifeline BookFest, facilitated holiday coaching clinics for
                vulnerable youth, coordinated school visits, and participated in
                a 55-episode TV series to amplify voices across sport and
                community. <br></br>
                <br></br>Our commitment to growth is evident through our regular
                athlete advancement workshops, participation in regional town
                halls for our partners, cultural awareness training sessions,
                keynote speaking engagements, and leadership skills development.
                At WattleNest, giving back is not an add-on — it’s part of who
                we are.
              </p>
              {/* <ul className="mt-5 text-xl font-josefin">
                <li>Lifeline BookFest</li>
                <li>
                  Facilitated Holiday Coaching Clinics for Vulnerable Youth
                </li>
                <li>Co-ordinated School Visists</li>
                <li>
                  55 TV Episodes to amplify voices across sport and community
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
